import React from "react";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { fantasyTheme } from './theme/fantasyTheme';
import '@fontsource/medievalsharp';
import '@fontsource/merriweather';
import '@fontsource/cinzel-decorative/700.css';
import ColorModal from './components/CharacterModal';
import PaintTool from './components/PaintTool';
import { useGameSession } from './hooks/useGameSession';
import { MODE } from './constants/gameConstants';
import GameSidebar from './components/GameSidebar';
import TokenPanel from './components/panels/TokenPanel';
import TokenDragPreview from './components/panels/TokenDragPreview';
import GameGrid from './components/GameGrid';
import ZoomControls from './components/ZoomControls';
import FloatingMapActions from './components/FloatingMapActions';
import { RoomDeletedDialog } from './components/shared/GameModals';
import {
  MedievalBackground,
  ContentWrapper,
  GameContainer,
} from './components/shared/StyledComponents';
import MapActivationContextBar from './components/shared/MapActivationContextBar';
import ObjectContextMenu from './components/shared/ObjectContextMenu';
import AppWatermark from './components/shared/AppWatermark';
import CoinContextOverlay from './components/CoinContextOverlay';
import { GameContext } from './context/GameContext';

const GridAndGlory = () => {
  const {
    gameContextValue,
    gameContainerRef,
    gameGridRef,
    gameSidebarRef,
    mode,
  } = useGameSession();

  return (
    <ThemeProvider theme={fantasyTheme}>
      <CssBaseline />
      <GameContext.Provider value={gameContextValue}>
        <MedievalBackground>
          <GameSidebar
            ref={gameSidebarRef}
            fixedPanelSlot={mode === MODE.TOKEN ? <TokenPanel /> : null}
          />

          <ContentWrapper sx={{ paddingLeft: mode === MODE.TOKEN ? '280px' : 0 }}>
          <GameContainer ref={gameContainerRef}>
            <MapActivationContextBar />

            <GameGrid ref={gameGridRef} />

            <ColorModal />

            <PaintTool />

            <ZoomControls />

            <FloatingMapActions />

            <ObjectContextMenu />

            <CoinContextOverlay />
          </GameContainer>
          </ContentWrapper>

          <AppWatermark />

          <RoomDeletedDialog />

          <TokenDragPreview />
        </MedievalBackground>
      </GameContext.Provider>
    </ThemeProvider>
  );
};

export default GridAndGlory;
